import * as SerializerLib from "jsonapi-serializer";

import { serializeError } from "../base.serializer";

const JSONAPISerializer = SerializerLib.Serializer;

const opts = {
  attributes: ["login", "password"]
};

const changePasswordOpts = {
  attributes: ["oldPassword", "newPassword", "newPasswordConfirmation"]
};

const profileOpts = {
  attributes: [
    "id",
    "login",
    "email",
    "roleName",
    "type",
    "imageUrl",
    "lastSeenAt",
    "createdAt",
    "oldPassword",
    "newPassword",
    "newPasswordConfirmation",
    "emailOrLogin",
    "password",
    "rememberMe",
    "otp",
    "name"
  ]
};

export const serialize = (data) => {
  try {
    const Serializer = new JSONAPISerializer("user", opts);
    return Serializer.serialize(data);
  } catch (err) {
    return serializeError(err);
  }
};

export const serializeChangePassword = (data) => {
  try {
    const Serializer = new JSONAPISerializer("user", changePasswordOpts);
    return Serializer.serialize(data);
  } catch (err) {
    return serializeError(err);
  }
};

export const serializeProfile = (data) => {
  try {
    const Serializer = new JSONAPISerializer("user", profileOpts);
    return Serializer.serialize(data);
  } catch (err) {
    return serializeError(err);
  }
};
